import requestCommon from "@/components/web-interface/requestCommon";
const state = {
    StrategyData: null,
};
const actions = {
    getStrategyData(context, data) {
        return requestCommon.getInfo(
            "/strategy/pnl?from=" + data.fromDate + "&to=" + data.toDate,
            data,
            null,
            context,
            "getStrategyDataSuccessHandler",
            "getStrategyDataErrorHandler"
        );
    },
}
const mutations = {
    getStrategyDataSuccessHandler(state, data) {
        state.StrategyDataData = data.server.data;
    },
    getStrategyDataErrorHandler(context, error,) {
        console.log(error);
    },
};
const getters = {};
export const strategyDashboard = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}